import { render, staticRenderFns } from "./MenuCommonSub.vue?vue&type=template&id=28038276&scoped=true"
import script from "./MenuCommonSub.vue?vue&type=script&lang=js"
export * from "./MenuCommonSub.vue?vue&type=script&lang=js"
import style0 from "./MenuCommonSub.vue?vue&type=style&index=0&id=28038276&lang=scss&scoped=true"
import style1 from "./MenuCommonSub.vue?vue&type=style&index=1&id=28038276&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28038276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28038276')) {
      api.createRecord('28038276', component.options)
    } else {
      api.reload('28038276', component.options)
    }
    module.hot.accept("./MenuCommonSub.vue?vue&type=template&id=28038276&scoped=true", function () {
      api.rerender('28038276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/advancecomponets/children/MenuCommonSub.vue"
export default component.exports